export const SCRIPS_DEFAULT: Scrips = {
  INDEX: {
    NSE_INDEX: [],
    BSE_INDEX: [],
    MCX_INDEX: [],
  },
  EQ: {
    NSE_EQ: [],
    BSE_EQ: [],
  },
  FUT: {
    BSE_FO: [],
    NSE_FO: [],
    BCD_FO: [],
    NCD_FO: [],
    MCX_FO: [],
    NSE_COM: [],
  },
  OPT: {
    BSE_FO: [],
    NSE_FO: [],
    BCD_FO: [],
    NCD_FO: [],
    MCX_FO: [],
    NSE_COM: [],
  },
};
